export class StaffMember {
    id: number;
    name: string;
    description: string;
    hasPicture: boolean;
    hasBackground: boolean;
    hasIcon: boolean;
}
